export enum TMTCameraDeviation {
    Deviation = "Deviation",
    Normal = "Normal",
    High_Severity = "high_severity"
  }